// Route Groups
import VerificationRoutes from './verification'
import ForgotPasswordRoutes from './forgotPassword'

// Route Pages

const SimulateCustomer = () => import('../../components/common/pages/SimulateCustomer.vue')
const Login = () => import('../../components/common/pages/Login.vue')
const NetworkError = () => import('../../components/common/pages/NetworkError.vue')
const Register = () => import('../../components/common/pages/Register.vue')
const CompleteProfile = () => import('../../components/referral/pages/CompleteProfile.vue')
const GuestDocumentVerification = () => import('../../components/common/pages/GuestDocumentVerification.vue')
const LoanDocumentUpload = () => import('../../components/loans/pages/common/LoanDocumentUpload.vue')
const MobileVerifyConfirm = () => import('../../components/common/pages/ProvePhoneVerification/MobileVerifyConfirm.vue')

// Route Parents
const GenericParent = () => import('../../components/common/pages/GenericParent.vue')

export default () => {
  return [
    {
      path: '',
      name: 'Login',
      component: Login,
      props: true
    },
    {
      path: 'NetworkError',
      name: 'NetworkError',
      component: NetworkError,
      props: true
    },
    {
      path: 'Register',
      name: 'Register',
      component: Register,
      props: true
    },
    {
      path: 'SimulateCustomer',
      name: 'SimulateCustomer',
      component: SimulateCustomer,
      props: true
    },
    {
      path: 'Verification',
      component: GenericParent,
      meta: { flow: 'Verification' },
      props: true,
      children: VerificationRoutes()
    },
    {
      path: 'ForgotPassword',
      component: GenericParent,
      props: true,
      meta: { flow: 'ForgotPassword' },
      children: ForgotPasswordRoutes()
    },
    {
      path: 'ReferCompleteProfile',
      name: 'ReferCompleteProfileUnauth',
      component: CompleteProfile,
      props: true
    },
    {
      path: '/GuestDocumentVerification',
      name: 'GuestDocumentVerificationUnauth',
      component: GuestDocumentVerification,
      props: true
    },
    {
      path: '/LoanDocumentUpload',
      name: 'LoanDocumentUploadUnauth',
      component: LoanDocumentUpload,
      props: true
    },
    {
      path: '/MobileVerifyConfirm',
      name: 'MobileVerifyConfirm',
      component: MobileVerifyConfirm,
      props: true
    }
  ]
}
